import type { EmployeeViewModelWithName, State } from '../../types';

import { toList } from '../toList';

export function employeesDeleted(state: State): EmployeeViewModelWithName[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.employeesById).filter(function (e) {
    return e.deleted;
  });
}
